// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from "firebase/app";

// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import "firebase/analytics";

// Add the Firebase products that you want to use
import "firebase/auth";
import "firebase/firestore";
import "firebase/database";

// Firebase init
// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
    apiKey: "AIzaSyCsW93PT4bVZiB7pflXzxHjLPv9mmXkfls",
    authDomain: "notes-app-ead74.firebaseapp.com",
    databaseURL: "https://notes-app-ead74.firebaseio.com",
    projectId: "notes-app-ead74",
    storageBucket: "notes-app-ead74.appspot.com",
    messagingSenderId: "706124843749",
    appId: "1:706124843749:web:f756a982bbb1633cb1e20c",
    measurementId: "G-91663RZD7J"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();
firebase.database();

export const firebaseSdk = firebase;